import { useEffect, useState, useRef } from 'react';
import { Select } from 'antd';
import { Api_v2 } from '../../services/api';
import { jsx as _jsx } from "react/jsx-runtime";
export const UserPicker = _ref => {
    let { initialIds, extraUsers = [], mode = "multiple", onChange, ...propsPropagate } = _ref;
    const [userOptions, setUserOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const lastUsedInitialIds = useRef(undefined);
    const [onClickHandler, setOnClickHandler] = useState(() => runOnlyOnceOnClickHandler);
    const userRequestParams = {};
    let onSearchTimeoutId;
    // busca opções na API (sem extraUsers)
    function getAndSetOptions(request) {
        setIsLoading(true);
        Api_v2.User.getAll(request).then(r => {
            const fetched = r.data.response.items.map(e => ({
                value: e.id,
                label: e.name
            }));
            setUserOptions(fetched);
        }).finally(() => {
            setIsLoading(false);
        });
    }
    // carrega se initialIds mudarem
    useEffect(() => {
        if (!initialIds || initialIds.length === 0)
            return;
        const last = lastUsedInitialIds.current;
        const areDifferent = !last || last.length !== initialIds.length || last.some((id, idx) => id !== initialIds[idx]);
        if (areDifferent) {
            lastUsedInitialIds.current = initialIds;
            getAndSetOptions({
                ...userRequestParams,
                filterIDs: initialIds
            });
        }
    }, [initialIds]);
    // clique inicial
    function runOnlyOnceOnClickHandler() {
        setOnClickHandler(undefined);
        getAndSetOptions(userRequestParams);
    }
    // debounce search
    function onSearchHandler(search) {
        setSearchValue(search);
        window.clearTimeout(onSearchTimeoutId);
        onSearchTimeoutId = window.setTimeout(() => {
            userRequestParams.searchText = search;
            getAndSetOptions(userRequestParams);
        }, 300);
    }
    // handler para limpar o texto de busca quando um item é selecionado
    function handleChange(value, option) {
        setSearchValue('');
        if (onChange) {
            onChange(value, option);
        }
    }
    // aqui, uni EXTRA + FETCHED
    const mergedOptions = [...(extraUsers || []), ...(userOptions || [])];
    return /*#__PURE__*/ _jsx(Select, {
        autoClearSearchValue: true,
        filterOption: false,
        showArrow: true,
        showSearch: true,
        searchValue: searchValue,
        onClick: !initialIds || initialIds.length === 0 ? onClickHandler : undefined,
        allowClear: true,
        loading: isLoading,
        mode: mode,
        onSearch: onSearchHandler,
        onChange: handleChange,
        options: mergedOptions,
        ...propsPropagate
    });
};
